import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { apiGet } from '../../../services/apiFetch';
import '../../../styles/PlayerDetails.css';

const PlayerDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [player, setPlayer] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPlayer = async () => {
            try {
                const { data, error } = await apiGet(`/api/rl/players/${id}`);
                if (error) throw new Error(error.error);
                const player = data.player;
                setPlayer(player);
            } catch (err) {
                console.error('Error fetching player:', err);
            } finally {
                setLoading(false);
            }
        };
        fetchPlayer();
    }, [id]);

    if (loading) return <div className="spinner"></div>;
    if (!player) return <div className="no-results">Player not found</div>;

    return (
        <div className="player-details">
            <div className="admin-player-header">
                <div className='player-form-buttons'>
                    <button onClick={() => navigate(-1)} className="back-button">
                        ← Back
                    </button>
                    <div className='player-form-buttons-right'>
                        <Link to={`/admin/players/edit/${id}`} className="basic-button" state={{ player }}>
                            Edit Profile
                        </Link>
                    </div>
                </div>
                <div className="player-profile-section">
                    <div className="player-info">
                        <div className="player-info-item player-name-with-image">
                            <div className="player-profile-image">
                                <img
                                    src={player.image || '/assets/images/placeholder.png'}
                                    alt={player.username}
                                    className="player-logo-detail"
                                    onError={e => (e.target.src = '/assets/images/placeholder.png')}
                                />
                            </div>
                            <div className="player-name-content">
                                <span className="info-label">Username</span>
                                <span className="info-value">{player.username}</span>
                            </div>
                        </div>
                        <div className="player-info-item">
                            <span className="info-label">Full Name</span>
                            <span className="info-value">{player.name || '-'}</span>
                        </div>
                        <div className="player-info-item">
                            <span className="info-label">Date of Birth</span>
                            <span className="info-value">{player.DOB || '-'}</span>
                        </div>
                        <div className="player-info-item">
                            <span className="info-label">Country</span>
                            <span className="info-value">{player.country || '-'}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default PlayerDetails;